import { render, staticRenderFns } from "./EvaluationAssessmentsSelectbox.vue?vue&type=template&id=b0716558&"
import script from "./EvaluationAssessmentsSelectbox.vue?vue&type=script&lang=js&"
export * from "./EvaluationAssessmentsSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports